<template>
  <v-footer id="footer" class="pa-0">
    <v-container class="pt-9 pb-9 px-4 ">
      <v-row class="mb-10">
        <v-col class="footer-item col-8 col-sm-8 col-md-2 pa-0">
          <div>
            <v-img
              alt="Logo"
              class="mr-2 logo-image"
              contain
              :src="require('../../assets/footer-logo.png')"
              transition="scale-transition"
              width="110"
            />
          </div>
        </v-col>
        <v-col class="footer-item col-4 col-sm-4 col-md-2 pa-0 qr-code mobile">
          <ul>
            <li class='mb-3'>
              <v-img
                alt="Supplier"
                class="mb-1 supplier-image"
                contain
                :src="require('../../assets/images/supplier.png')"
                transition="scale-transition"
                width="70"
              />
              <span>供应商APP</span>
            </li>
            <li>
              <v-img
                alt="Purchaser"
                class="mb-1 purchaser-image"
                contain
                :src="require('../../assets/images/purchaser.png')"
                transition="scale-transition"
                width="70"
              />
              <span>采购商APP</span>
            </li>
          </ul>
        </v-col>
        <v-col class="footer-item col-12 col-sm-8 col-md-6 pa-0">
          <div class="f-title mb-6">
            <span class="py-1">友情链接</span>
          </div>
          <ul class="link-list">
            <li  v-for="item in partner" :key="item.id" @click="hrefItem(item)" class="mb-4 footer-link">{{item.title}}</li>
          </ul>
        </v-col>
        <v-col class="footer-item col-12 col-sm-4 col-md-2 pa-0">
          <div class="f-title mb-6">
            <span class="py-1">关于</span>
          </div>
          <ul>
            <li  v-for="item in aboutUs" :key="item.id" @click="pathItem(item)" class="mb-4 footer-link">{{item.title}}</li>
          </ul>
        </v-col>
        <v-col class="footer-item col-12 col-sm-4 col-md-2 pa-0 qr-code">
          <ul>
            <li class='mb-3'>
              <v-img
                alt="Supplier"
                class="mb-1 supplier-image"
                contain
                :src="require('../../assets/images/supplier.png')"
                transition="scale-transition"
                width="70"
              />
              <span>供应商APP</span>
            </li>
            <li>
              <v-img
                alt="Purchaser"
                class="mb-1 purchaser-image"
                contain
                :src="require('../../assets/images/purchaser.png')"
                transition="scale-transition"
                width="70"
              />
              <span>采购商APP</span>
            </li>
          </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-12 pa-0">
          <div class="copy-right text-center">版权所有：福州城投供应链集团有限公司</div>
          <div class="copy-right text-center"><a href="https://beian.miit.gov.cn" target="_blank">备案号：闽ICP备2020020263号-1</a></div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  data: () => {
    return {
      partner: [{
        id: 0,
        title: '信用中国',
        path: 'https://www.creditchina.gov.cn/'
      }, {
        id: 1,
        title: '中国水泥网',
        path: 'http://www.ccement.com/'
      }, {
        id: 2,
        title: '我的钢铁网',
        path: 'https://www.mysteel.com/'
      }, {
        id: 3,
        title: '中国政府采购网',
        path: 'http://www.ccgp.gov.cn/'
      }, {
        id: 4,
        title: '福建省政府采购网',
        path: 'http://ccgp-fujian.gov.cn/'
      }, {
        id: 5,
        title: '中国招投标电子交易平台',
        path: 'https://www.okcis.cn/weiyizhidingzbpt/h1xzxz987'
      }, {
        id: 6,
        title: '福建省公共资源交易电子公共服务平台',
        path: 'https://ggzyfw.fujian.gov.cn/'
      }],
      aboutUs: [{
        id: 0,
        title: '招采信息',
        path: '/engineering'
      }, {
        id: 1,
        title: '公示信息',
        path: '/logistics'
      }]
    }
  },
  methods: {
    hrefItem (item) {
      window.open(item.path, '_blank')
    },
    pathItem (item) {
      this.$router.push(item.path)
    }
  }
}
</script>

<style lang="scss" scoped>
#footer {
  background-color: #1b2020;
  color: #FFF;
  .qr-code li.mb-3 {
    float: left;
    margin-right: 15px;
  }
  .qr-code {
    display: none;
  }
  .qr-code.mobile {
    display: block;
  }
  @media (min-width: 960px) {
    .qr-code {
      display: block;
    }
    .qr-code.mobile {
      display: none;
    }
  }
  .footer-link {
    cursor: pointer;
  }
  .footer-item {
    margin-bottom: 16px;
  }
  .link-list {
    li {
      display: inline-block;
      margin-right: 15px;
    }
  }
  .f-title {
    span {
      position: relative;
      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: -2px;
        width: 100%;
        height: 2px;
        background-color: #FFF;
      }
    }
  }
  ul {
    list-style: none;
    padding-left: 0;
  }
}
</style>
